<template>
  <button
    :class="{
      'is-busy': busy,
      'button--solid': solid
    }"
    :disabled="busy || $attrs.disabled"
    v-bind="$attrs"
    class="button"
    v-on="$listeners"
  >
    <c-busy class="button__busy" />
    <span class="button__content">
      <slot/>
    </span>
  </button>
</template>

<script>
import BButton from '@/components/base/BButton.vue'
import CBusy from '@/components/CBusy.vue'

export default {
  name: 'CButton',

  components: {
    CBusy
  },

  extends: BButton,

  props: {
    busy: {
      type: Boolean
    }
  }
}
</script>
